module.exports = __webpack_public_path__ + "static/media/momentjs.6a23d034.svg";